<app-dialog-header [title]="'GENERAL.BUTTON.EDIT_VALIDITY_PERIOD'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div class="p-24" fxLayout="column" fxLayoutAlign="start">
    <form class="new-audience-form" *ngIf="formGroup" [formGroup]="formGroup">
        <!-- Start Date -->
        <mat-form-field class="w-100-p">
            <input
                matInput
                name="startDate"
                [min]="minDate"
                [max]="maxDate"
                formControlName="startDate"
                [matDatepicker]="pickerStartDate"
                [placeholder]="'GENERAL.PROPERTY.START_DATE' | translate"
                (click)="pickerStartDate.open()"
                (ngModelChange)="updateEndDate()"
            />
            <mat-datepicker-toggle matSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
            <mat-datepicker #pickerStartDate></mat-datepicker>
        </mat-form-field>

        <div fxLayout="column" class="p-16 bg-zinc-50 rounded-md">
            <!-- Toggle -->
            <mat-slide-toggle (change)="toggleEndDate($event)" [checked]="showEndDate">
                {{ 'GENERAL.PROPERTY.END_DATE' | translate }}
            </mat-slide-toggle>

            <!-- End Date only if toggle on -->
            <mat-form-field class="w-100-p" *ngIf="showEndDate">
                <input
                    matInput
                    name="endDate"
                    [max]="maxDate"
                    formControlName="endDate"
                    [matDatepicker]="pickerEndDate"
                    [placeholder]="'GENERAL.PROPERTY.END_DATE' | translate"
                    (click)="pickerEndDate.open()"
                    (ngModelChange)="updateStartDate()"
                />
                <mat-datepicker-toggle matSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerEndDate></mat-datepicker>
            </mat-form-field>
        </div>

        <!-- Priority -->
        <mat-form-field>
            <mat-label>{{ 'ENGAGE.SCHEDULE_FEATURED_CONTENT.PRIORITY.TITLE' | translate }}</mat-label>
            <mat-select formControlName="priority">
                <mat-option value="low">{{ 'ENGAGE.SCHEDULE_FEATURED_CONTENT.PRIORITY.TYPE.LOW' | translate }}</mat-option>
                <mat-option value="medium">{{ 'ENGAGE.SCHEDULE_FEATURED_CONTENT.PRIORITY.TYPE.MEDIUM' | translate }}</mat-option>
                <mat-option value="high">{{ 'ENGAGE.SCHEDULE_FEATURED_CONTENT.PRIORITY.TYPE.HIGH' | translate }}</mat-option>
            </mat-select>
        </mat-form-field>
    </form>
</div>

<div class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="onScheduleDate()"></app-flat-button>
</div>
